import { Route, Routes } from 'react-router-dom'
import ShopsPage from '../../pages/shared-pages/shops/ShopsPage'
import ShopDetailsPage from '../../pages/shared-pages/shops/ShopDetailsPage'
import NewShopPage from '../../pages/shared-pages/shops/NewShopPage'
import UpdateShopPage from '../../pages/shared-pages/shops/UpdateShopPage'

export default function ShopNav() {
    return (
        <Routes>

            <Route path="/" element={<ShopsPage />} />
            <Route path="/new" element={<NewShopPage />} />
            <Route path="/update" element={<UpdateShopPage />} />

            <Route path="/details" element={<ShopDetailsPage />} />

        </Routes>
    )
}
